const PROJECT_TYPE_MAP = {
  web_store: 'Web Store',
  payment_links: 'Payment Links',
  web_checkout: 'Web Checkout',
  side_loading: 'AppDirect'
};

export const getSolutionModelInfo = (isWebStore: boolean, isPaymentLinks: boolean, isSideLoading?: boolean) => {
  if (isWebStore) return PROJECT_TYPE_MAP.web_store;
  if (isPaymentLinks) return PROJECT_TYPE_MAP.payment_links;
  if (isSideLoading) return PROJECT_TYPE_MAP.side_loading;
  return PROJECT_TYPE_MAP.web_checkout;
};
